import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { DynamicFormsService } from 'src/app/services/dynamic-forms.service';


@Component({
    selector: 'app-form-view-text2',
    templateUrl: './form-view-text2.component.html',
    styleUrls: ['./form-view-text2.component.scss'],
    standalone: false
})
export class FormViewText2Component implements OnInit {

  toolTipText = null;
  config:columnsDef;
  group: UntypedFormGroup;
  showBuscaDados:boolean = true;
  row:Object;
  @Output() editEvent:EventEmitter<boolean> = new EventEmitter();
  entityName:string;
  entityDesc:string;
  tabindex:string;
  canConfig:boolean = false;

  @Output() blurEvent:EventEmitter<boolean> = new EventEmitter();
  bluring(event){
      this.blurEvent.next(event)
  }
  
  constructor(public dynaServices:DynamicFormsService) {  }

  ngOnInit() {

  }

  
  ngAfterViewInit(){
    
  }

  editing(){
    this.editEvent.next(true)
  }
}
